export default "__VITE_ASSET__49608386__"